/* eslint-disable no-undef */
// Frontend build-time version. Webpack's DefinePlugin substitutes the
// literal compile-time values for __BUILD_SHORT__ and __BUILD_TIME__ so
// this file is effectively a static constant after build — no runtime
// lookup needed. Format:
//   APP_VERSION  = "YYMMDD.HHMM" (compact, sortable, UTC)
//   APP_BUILD_AT = full ISO timestamp (for tooltip)
// Auto-updates every build; no manual bump required.

export const APP_VERSION =
  typeof __BUILD_SHORT__ !== "undefined" ? __BUILD_SHORT__ : "dev";

export const APP_BUILD_AT =
  typeof __BUILD_TIME__ !== "undefined" ? __BUILD_TIME__ : null;
